import compose from 'ramda/src/compose'
import split from 'ramda/src/split'
import prop from 'ramda/src/prop'

export default compose(
	prop(1),
	split('-'),
)
